import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hamburger",
  "use": "icon-hamburger-usage",
  "viewBox": "0 0 14 13",
  "content": "<symbol viewBox=\"0 0 14 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-hamburger\"><g fill-rule=\"evenodd\"><path d=\"M.5 0H13v1H.5a.5.5 0 1 1 0-1zM14 1v11a1 1 0 0 1-1 1V0a1 1 0 0 1 1 1z\" /><rect x=\"5\" y=\"4\" width=\"9\" height=\"1\" rx=\".5\" /><rect x=\"5\" y=\"8\" width=\"9\" height=\"1\" rx=\".5\" /><path d=\"M.5 12H13v1H.5a.5.5 0 1 1 0-1zM0 6.5L3 4v5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol